import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.number.constructor";
/**
 * Verify 验证码组件
 * @description 分发验证码使用
 * */
import VerifySlide from "./Verify/VerifySlide";
import VerifyPoints from "./Verify/VerifyPoints";
export default {
  name: 'Vue2Verify',
  props: {
    // 双语化
    locale: {
      require: false,
      type: String,
      default: function _default() {
        // 默认语言不输入为浏览器语言
        if (navigator.language) {
          var language = navigator.language;
        } else {
          var language = navigator.browserLanguage;
        }
        return language;
      }
    },
    captchaType: {
      type: String,
      required: true
    },
    figure: {
      type: Number
    },
    arith: {
      type: Number
    },
    mode: {
      type: String,
      default: 'pop'
    },
    vSpace: {
      type: Number
    },
    explain: {
      type: String
    },
    imgSize: {
      type: Object,
      default: function _default() {
        return {
          width: '310px',
          height: '155px'
        };
      }
    },
    blockSize: {
      type: Object
    },
    barSize: {
      type: Object
    }
  },
  data: function data() {
    return {
      // showBox:true,
      clickShow: false,
      // 内部类型
      verifyType: undefined,
      // 所用组件类型
      componentType: undefined
    };
  },
  methods: {
    /**
     * i18n
     * @description 兼容vue-i18n 调用$t来转换ok
     * @param {String} text-被转换的目标
     * @return {String} i18n的结果
     * */
    i18n: function i18n(text) {
      if (this.$t) {
        return this.$t(text);
      } else {
        // 兼容不存在的语言
        var i18n = this.$options.i18n.messages[this.locale] || this.$options.i18n.messages['en-US'];
        return i18n[text];
      }
    },
    /**
     * refresh
     * @description 刷新
     * */
    refresh: function refresh() {
      if (this.instance.refresh) {
        this.instance.refresh();
      }
    },
    closeBox: function closeBox() {
      this.clickShow = false;
      this.refresh();
    },
    show: function show() {
      if (this.mode == "pop") {
        this.clickShow = true;
      }
    }
  },
  computed: {
    instance: function instance() {
      return this.$refs.instance || {};
    },
    showBox: function showBox() {
      if (this.mode == 'pop') {
        return this.clickShow;
      } else {
        return true;
      }
    }
  },
  watch: {
    captchaType: {
      immediate: true,
      handler: function handler(captchaType) {
        switch (captchaType.toString()) {
          case 'blockPuzzle':
            this.verifyType = '2';
            this.componentType = 'VerifySlide';
            break;
          case 'clickWord':
            this.verifyType = '';
            this.componentType = 'VerifyPoints';
            break;
        }
      }
    }
  },
  components: {
    VerifySlide: VerifySlide,
    VerifyPoints: VerifyPoints
  }
};